import React from "react";
import { Row, Col, Result, Button } from "antd";
import { SmileTwoTone } from "@ant-design/icons";

const PageNotFound = ({ history }) => {

  const redirectToHomepage = () => {
    history.push("/");
  };


  return (
    <div>
      <Row justify="center" align="middle">
        <Col style={{ flexGrow: 0 }}>
          <Result
            icon={<SmileTwoTone />}
            title={
              <>
                <h1
                  style={{
                    textAlign: "center",
                    fontSize: "40px",
                    fontWeight: "400",
                  }}
                >
                  Greška <span style={{ fontWeight: "600" }}>404</span>
                </h1>
                Odabrana stranica ne postoji, premještena je ili obrisana.
                Provjerite jeste li upisali ispravnu adresu.
              </>
            }
            extra={
              <Button type="primary" onClick={redirectToHomepage}>
                Povratak na početnu
              </Button>
            }
          />
        </Col>
      </Row>
    </div>
  );
};

export default PageNotFound;
